export default __webpack_public_path__ + "static/media/demo-risk.560bc5e1.png";